var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-text',{staticClass:"text-left",staticStyle:{"max-height":"430px","overflow-y":"auto"}},[(!_vm.loading)?[_c('p',{domProps:{"innerHTML":_vm._s(_vm.consentdata.consent_details)}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }